module.exports = __webpack_public_path__ + "img/padlock.349d1a8e.gif";